var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4998 7.20005C14.991 7.20005 16.1998 5.99122 16.1998 4.50005C16.1998 3.00888 14.991 1.80005 13.4998 1.80005C12.0086 1.80005 10.7998 3.00888 10.7998 4.50005C10.7998 4.61298 10.8067 4.7243 10.8202 4.8336L6.37414 7.05663C5.88853 6.58818 5.22782 6.30005 4.4998 6.30005C3.00863 6.30005 1.7998 7.50888 1.7998 9.00005C1.7998 10.4912 3.00863 11.7 4.4998 11.7C5.22783 11.7 5.88856 11.4119 6.37417 10.9434L10.8202 13.1665C10.8067 13.2758 10.7998 13.3871 10.7998 13.5C10.7998 14.9912 12.0086 16.2 13.4998 16.2C14.991 16.2 16.1998 14.9912 16.1998 13.5C16.1998 12.0089 14.991 10.8 13.4998 10.8C12.7718 10.8 12.1111 11.0882 11.6255 11.5566L7.1794 9.3336C7.19287 9.2243 7.1998 9.11299 7.1998 9.00005C7.1998 8.8871 7.19286 8.77577 7.1794 8.66646L11.6254 6.44344C12.111 6.91191 12.7718 7.20005 13.4998 7.20005Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.25e521678cff344aeede4999ba79c0c4.svg";
export { ForwardRef as ReactComponent };